/* side-nav-content.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./side-nav-content.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { forwardRef } from 'react';
/**
 * The main content slot of the side nav, filling up the middle section.
 */
export var SideNavContent = /*#__PURE__*/forwardRef(_SideNavContent);

// Placing this const below the function breaks Compiled!
var styles = {
  scrollContainer: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo1wug _18m91wug",
  paddingContainer: "_ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp"
};
function _SideNavContent(_ref, ref) {
  var children = _ref.children,
    testId = _ref.testId;
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    "data-testid": testId,
    className: ax([styles.scrollContainer])
  }, /*#__PURE__*/React.createElement("div", {
    className: ax([styles.paddingContainer])
  }, children));
}